<div class="pre-order-banner-container" *ngIf="showBanner()" [ngStyle]="{'margin-top': shrinkMargin === true ? '0px' : null}">
    <div class="pre-order-message" data-automation-label="Pre-Order-Message">
        Way to get ahead! This pre-order will give you access to {{product}} on or before {{date}}.
    </div>
    <div class="close-banner-container" (click)="closeBanner()" data-automation-action="Pre-Order-Close-Banner">
        <span class="hrb-icon hrb-toggle__icon">
            <img class="hrb-icon__container" src='assets/Line3.svg' alt="download" data-automation-action="Pre-Order-Close-Banner-Icon-0">
            <img class="hrb-icon__container hrb-icon-rotate" src='assets/Line3.svg' alt="download" data-automation-action="Pre-Order-Close-Banner-Icon-1">
        </span>
    </div>
</div>
<div [ngClass]="{'pre-order-banner-mobile-closed': closed}"></div>
